import React from "react";
import "../css/hero.css";
import bghero from "../assets/herobg.webp"; // background image

const Hero = () => {
  return (
    <section
      className="hero-section"
      aria-label="Hero section"
      style={{ backgroundImage: `url(${bghero})` }}
    >
      <div className="hero-overlay" />

      <div className="hero-inner">
        <div className="hero-card" role="region" aria-labelledby="hero-title">
          <div className="hero-pretitle">
            JAY AMBE AC SERVICE AND REPAIRING
          </div>

          {/* small blue divider under pretitle */}
          <div className="hero-divider" />

          <h1 id="hero-title" className="hero-title">
            Professional Air Conditioner <br />
            Repair and Service
          </h1>

          <p className="hero-desc">
            Looking for the best AC repair and service in Surat? At Jay Ambe AC
            Service, we provide quick and reliable AC repair, cleaning,
            installation, and maintenance services right at your doorstep.
            Our expert technicians ensure your AC runs smoothly and efficiently,
            keeping your home or office cool all year round.
          </p>

          {/* red highlighted line above the call button */}
          <div className="hero-highlight">
            AC service at your doorstep in 30 minutes
          </div>

          <div className="hero-cta">
            <span className="cta-label">Call Now</span>

            <a
              className="phone-button"
              href="tel:7237898275"
              onClick={() =>
                window.gtag_report_conversion("tel:7237898275")
              }
            >
              72378 98275
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;